import { render, staticRenderFns } from "./WafRuleInfo.vue?vue&type=template&id=ec62d57a"
import script from "./WafRuleInfo.vue?vue&type=script&lang=js"
export * from "./WafRuleInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports